import { render } from "./ViewWebsiteModal.vue?vue&type=template&id=b4d9b864&scoped=true&ts=true"
import script from "./ViewWebsiteModal.vue?vue&type=script&lang=ts"
export * from "./ViewWebsiteModal.vue?vue&type=script&lang=ts"

import "./ViewWebsiteModal.vue?vue&type=style&index=0&id=b4d9b864&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4d9b864"]])

export default __exports__